(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.pppMenuPopIn = {
    attach: function (context, settings) {
      window.pppMenuPopIn = {
        "closePopIn": function (dropdownNotToClose, elementToFocus) {
          $('body').removeClass('ppp-modal-open');
          $('.menu-pop-in').removeClass('menu-pop-in-open');

          if (dropdownNotToClose) {
            $('.dropdown.menu > li:not(' + dropdownNotToClose + ')').removeClass('is-active is-open');
          } else {
            $('.dropdown.menu > li').removeClass('is-active is-open');
          }

          // focus element to focus, if one is set
          if ($(elementToFocus)) {
            $(elementToFocus).focus();
          }

        },
        "openPopIn": function (popInSelector, dropbuttonWrapperselector, elementToFocus) {
          if ($(popInSelector)) {
            $('body').addClass('ppp-modal-open');
            $(popInSelector).addClass('menu-pop-in-open');
            $(dropbuttonWrapperselector).addClass('is-open');
            if ($(elementToFocus)) {
              $(elementToFocus).focus();
            }
          }
        },
        "togglePopIn": function (popInSelector, dropbuttonWrapperselector, elementToFocus) {
          if ($(popInSelector).hasClass('menu-pop-in-open')) {
            this.closePopIn();
          } else {
            this.closePopIn();
            this.openPopIn(popInSelector, dropbuttonWrapperselector, elementToFocus);
          }
        },
        "swipeToClose": function (elementToFocus) {
          $('#left-off-canvas-menu').removeClass('is-open');
          $('.js-off-canvas-overlay').removeClass('is-visible is-closable');
          // focus element to focus, if one is set
          if ($(elementToFocus)) {
            $(elementToFocus).focus();
          }
        },
        "onMenuPopinOpen": function () {
          // On ajotue un tabindex pour la nav clavier uniquement quand le menu est open.
          document
            .querySelector('#left-off-canvas-menu')
            .querySelectorAll('a, [tabindex]')
            .forEach(function (item) {
              if (item.hasAttribute('data-real-tabindex')) {
                item.setAttribute('tabindex', item.getAttribute('data-real-tabindex'));
              }
              else{
                item.setAttribute('tabindex', 0)
              }
            });
        },
        "onMenuPopinClose": function () {
          // On supprime le tabindex pour la nav clavier uniquement quand le menu est close.
          document
            .querySelector('#left-off-canvas-menu')
            .querySelectorAll('a, [tabindex]')
            .forEach(function (item) {
              // On stock le tabindex initial si existant.
              if (item.hasAttribute('tabindex')) {
                item.setAttribute('data-real-tabindex', item.getAttribute('tabindex'))
              }

              // On passe le tab index à -1. (reco rgaa 12.8)
              item.setAttribute('tabindex', -1)
            });
        },
      };

      $('.ppp-modal-background').click(function () {
        window.pppMenuPopIn.closePopIn();
      });

      $('.js-off-canvas-overlay, .off-canvas-wrapper').on('swipeleft', function () {
        window.pppMenuPopIn.swipeToClose('#burger-menu');
      });


      // Initialisation de la gestion de la nav clavier.
      window.pppMenuPopIn.onMenuPopinClose();
      var asideMenu = context.querySelector('#left-off-canvas-menu')
      if (asideMenu) {
        // On close le menu quand le focus sort du menu
        document
          .querySelector('#left-off-canvas-menu *')
          .addEventListener('focusout', function(evt){
            // si l'élément focus est hors menu, on ferme le menu.
            if( evt.relatedTarget && $(evt.relatedTarget).parents('#left-off-canvas-menu').length < 1 ){
              window.pppMenuPopIn.swipeToClose();
            }
          } );

        // On affecte le mutation observer sur le menu pour identifier les états open et close.
        this.addMutationObserver(
          asideMenu,
          ['class'],
          function (target, mutation, mutationList) {
            if (target.classList.contains('is-open')) {
              window.pppMenuPopIn.onMenuPopinOpen();
            } else {
              window.pppMenuPopIn.onMenuPopinClose();
            }
          })

      }


    },

    /**
     * Ajoute un mutation observer.
     */
    addMutationObserver: function (target, attributes, callback) {
      var config = {
          attributes: true,
        },
        observer = new MutationObserver(function (mutationList, mutationObserver) {
          for (var i in mutationList) {
            if (attributes.indexOf(mutationList[i].attributeName) > -1) {
              callback(target, mutationList[i], mutationList);
            }
          }
        });

      observer.observe(target, config);
    },
  };
})(jQuery, Drupal);
